<template>
  <el-tree
    ref="areaTree"
    :data="list"
    show-checkbox
    node-key="id"
    :default-expanded-keys="expanded_keys"
    :default-checked-keys="checked_keys"
    :props="defaultProps"
    @check="handleCheck"
    @node-click="nodeClick"
    v-loading="loading"
  >
  </el-tree>
</template>

<script>
import District from "~/services/district";
import elietschool from "~/services/elietschool";
import bus from "~/common/eventBus";
export default {
  name: "EliteSchoolArea",
  props: {
    customer: {},
    customer_id: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      list: [
        // {
        //   id: "0",
        //   label: "全部",
        //   pid: "0",
        //   level: 0,
        //   children: [
        //     {
        //       id: "1",
        //       label: "北京市",
        //       pid: "0",
        //       level: 0,
        //       children: [
        //         {
        //           id: "37",
        //           label: "东城区",
        //           pid: "1",
        //           level: 1,
        //           children: [
        //             {
        //               id: "567",
        //               label: "东华门街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "568",
        //               label: "东四街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "569",
        //               label: "东直门街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "570",
        //               label: "交道口街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "571",
        //               label: "北新桥街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "572",
        //               label: "和平里街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "573",
        //               label: "安定门街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "574",
        //               label: "建国门街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "575",
        //               label: "景山街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //             {
        //               id: "576",
        //               label: "朝阳门街道",
        //               pid: "37",
        //               level: 2,
        //             },
        //           ],
        //         },
        //         {
        //           id: "38",
        //           label: "西城区",
        //           pid: "1",
        //           level: 1,
        //           children: [
        //             {
        //               id: "577",
        //               label: "什刹海街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "578",
        //               label: "展览路街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "579",
        //               label: "德胜街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "580",
        //               label: "新街口街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "581",
        //               label: "月坛街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "582",
        //               label: "西长安街街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //             {
        //               id: "583",
        //               label: "金融街街道",
        //               pid: "38",
        //               level: 2,
        //             },
        //           ],
        //         },
        //         {
        //           id: "54",
        //           label: "延庆县",
        //           pid: "1",
        //           level: 1,
        //           children: [
        //             {
        //               id: "868",
        //               label: "井庄镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "869",
        //               label: "八达岭镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "870",
        //               label: "刘斌堡乡",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "871",
        //               label: "千家店镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "872",
        //               label: "四海镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "873",
        //               label: "大庄科乡",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "874",
        //               label: "大榆树镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "875",
        //               label: "康庄镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "876",
        //               label: "延庆镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "877",
        //               label: "张山营镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "878",
        //               label: "旧县镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "879",
        //               label: "永宁镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "880",
        //               label: "沈家营镇",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "881",
        //               label: "珍珠泉乡",
        //               pid: "54",
        //               level: 2,
        //             },
        //             {
        //               id: "882",
        //               label: "香营乡",
        //               pid: "54",
        //               level: 2,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
      loading: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      expanded_keys: [],
      checked_keys: [],
    };
  },
  created() {
    this.getList();
    this.getCheckedId();

  },
  methods: {
    getList() {
      this.loading = true;
      District.getZujuanTreeList().then((res) => {
        if (res.code == 0) {
          this.list = [
            {
              id: 0,
              label: "全部",
              children: res.data,
            },
          ];
          this.loading = false;
        }
      });
      return true;
    },

    getCheckedId() {
      this.loading = true;
      let params = {
        customer_id: parseInt(this.customer_id),
      };
      elietschool.selectZujuanDistrictId(params).then((res) => {
        if (res.code == 0) {
          this.expanded_keys = res.data;
          this.checked_keys = res.data;
          if(!this.checked_keys || this.checked_keys.length == 0){
            this.expanded_keys = [-1,this.customer.province_id];
            this.checked_keys = [-1,this.customer.province_id];
          }
        }
        this.loading = false;
      });
      return true;
    },

    handleCheck(data, obj) {
      this.loading = true;
      var is_all = 0;//是否全选
      var checked_keys = obj.checkedKeys;//获取选中key值数组
      //通过选中的结点数量变化，判断是点击勾选还是点击取消勾选
      if(data.id == 0){
        is_all = 2;//全部取消
        if(checked_keys.length > 0){
          //数量增加肯定就是点击了勾选
          is_all = 1;
        }
      }else if(checked_keys.includes(0)){
        is_all = 1;
      }else if(checked_keys.length == 0){
        is_all = 2;//全部取消
      }
      var params = {
        customer_id: parseInt(this.customer_id),
        district_ids: checked_keys,
        is_all: is_all
      };
      elietschool.zujuanDistrictCheck(params).then((res) => {
        this.loading = false;
        if (res.code) {
          this.$message({ type: "error", message: "设置更新失败" });
          this.getList();
          this.getCheckedId();
          return false;
        }
        this.$message({
          type: "success",
          message: "设置更新成功",
        });
        // bus.$emit('refresh', data);
        return true;
      });
      console.log(data, obj);
    },

    nodeClick(data, node, ojb){
      // bus.$emit('search', data);
      console.log('点击节点', data, node, ojb);
    }
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/zujuan/eliteSchoolArea.vue